require('./script/main.js');
